export default {
	auth: localStorage.getItem('AUTH') ? JSON.parse(localStorage.getItem('AUTH')) : {},
	user: localStorage.getItem('USER') ? JSON.parse(localStorage.getItem('USER')) : {},
	showNavigation: false
}
